module.exports = __webpack_public_path__ + "static/media/hotel-ad4.27cf1b1f.jpg";